/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PropertyWorkflowAction_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.PropertyWorkflowAction domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PropertyWorkflowAction_ {
   /// <summary>
   ///   Submitted to Accounting (acctsub)
   /// </summary>
   SubmittedToAccounting = 1,
   /// <summary>
   ///   Disapproved by Accounting (acctdspv)
   /// </summary>
   DisapprovedByAccounting = 2,
   /// <summary>
   ///   Approved by Accounting (acctappv)
   /// </summary>
   ApprovedByAccounting = 3
}

export const PropertyWorkflowActions: PropertyWorkflowAction[] = [
   {
      code: PropertyWorkflowAction_.SubmittedToAccounting,
      literal: 'SubmittedToAccounting',
      description: 'Submitted to Accounting',
      shortDescription: 'acctsub',
      listPriority: 1,

      typeName: "PropertyWorkflowAction"
   },
   {
      code: PropertyWorkflowAction_.DisapprovedByAccounting,
      literal: 'DisapprovedByAccounting',
      description: 'Disapproved by Accounting',
      shortDescription: 'acctdspv',
      listPriority: 2,

      typeName: "PropertyWorkflowAction"
   },
   {
      code: PropertyWorkflowAction_.ApprovedByAccounting,
      literal: 'ApprovedByAccounting',
      description: 'Approved by Accounting',
      shortDescription: 'acctappv',
      listPriority: 3,

      typeName: "PropertyWorkflowAction"
   }
]

export class PropertyWorkflowAction implements IDomainModel {
   code: PropertyWorkflowAction_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PropertyWorkflowAction_): PropertyWorkflowAction {
      return PropertyWorkflowActions.find(d => d.code === code)
   }
}
